<div class="dialog-agent">
  <h1 mat-dialog-title>
    {{ 'GLOBAL.REGENERATE-PIN-TITLE' | translate }}
  </h1>
  <div mat-dialog-content class="">

    <div class="row mx-0 pb-3">
      <div class="col-12 pb-2">
        <p class="m-0">
          {{ 'GLOBAL.REGENERATE-PIN-INFO' | translate }}
        </p>
      </div>
      <div class="col-12 py-2">
        <mat-form-field class="w-100">
          <mat-label class="">
            {{ 'GLOBAL.ACTIVATION-CODE' | translate }}
          </mat-label>
          <input matInput [placeholder]="'GLOBAL.INSERT-ACTIVATION-CODE' | translate" required autocomplete="off" type="text" [(ngModel)]="dataActivationCode" [ngModelOptions]="{standalone: true}" #activationCode="ngModel" required>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(activationCode.dirty || activationCode.touched) && activationCode.errors && activationCode.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 py-2">
        <mat-form-field class="w-100">
          <mat-label class="">
            {{ 'GLOBAL.NEW-PIN' | translate }}
          </mat-label>
          <input [type]="hidePinNew ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-NEW-PIN' | translate" matInput required minlength="4" maxlength="8" autocomplete="new-password" [(ngModel)]="dataNewPin" [ngModelOptions]="{standalone: true}" #newPin="ngModel"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-new-pin'" (click)="hidePinNew = !hidePinNew" [ngClass]="{'rt-view': hidePinNew, 'rt-hide': !hidePinNew}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(newPin.dirty || newPin.touched) && newPin.errors && newPin.errors.minlength">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(newPin.dirty || newPin.touched) && newPin.errors && newPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 py-2">
        <mat-form-field class="w-100">
          <mat-label class="">
            {{ 'GLOBAL.REPEAT-NEW-PIN' | translate }}
          </mat-label>
          <input [type]="hidePinRepeat ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-REPEAT-NEW-PIN' | translate" matInput required minlength="4" maxlength="8" autocomplete="new-password" [(ngModel)]="dataRepeatNewPin" [ngModelOptions]="{standalone: true}" #repeatPin="ngModel"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-repeat-new-pin'" (click)="hidePinRepeat = !hidePinRepeat" [ngClass]="{'rt-view': hidePinRepeat, 'rt-hide': !hidePinRepeat}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(repeatPin.dirty || repeatPin.touched) && repeatPin.errors && repeatPin.errors.minlength">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(repeatPin.dirty || repeatPin.touched) && repeatPin.errors && repeatPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(!repeatPin.errors) && dataNewPin && dataRepeatNewPin && (dataNewPin !== dataRepeatNewPin)">{{ 'GLOBAL.ERRORS.PIN-NO-EQUAL' | translate }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [disabled]="sendingInfo || !(dataActivationCode) || !(dataNewPin) || !(dataRepeatNewPin) || (dataNewPin !== dataRepeatNewPin)" (click)="sendPinReset();">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingInfo"></i>
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.REGENERATE' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" class="" [disabled]="sendingInfo" (click)="cancelChanges()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
